import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import BuildOptimizePortfolio from './BuildOptimize';
import OptimizedPortfolios from './OptimizedPortfolios';

class Optimize extends Component {
  constructor(props) {
    super(props);
    this.state = { optimizedWeights: [], riskMetric: 'variance' };
    this.handleUpdateState = this.handleUpdateState.bind(this);
  }

  handleUpdateState(value) {
    if (typeof value !== 'string') {
      const tickers = value.map((security) => security.ticker);
      this.setState({
        optimizedWeights: tickers,
      });
    }
    this.setState({ riskMetric: value });
  }

  renderBuildOptimize() {
    return (
      <BuildOptimizePortfolio
        match={this.props.match}
        buildoptimize={this.props.buildoptimize}
        dispatch={this.props.dispatch}
        isClientMode={this.props.isClientMode}
        user_region={this.props.user_region}
        handler={this.handleUpdateState}
      />
    );
  }

  renderOptimizedGraph(params) {
    return (
      <OptimizedPortfolios
        isClientMode={this.props.isClientMode}
        riskMetric={this.props.buildoptimize.riskMetric}
        dispatch={this.props.dispatch}
        dipatch={this.props.dispatch}
        handler={this.handleUpdateState}
        selectedHoldings={this.props.buildoptimize.portfolio}
        params={params}
      />
    );
  }

  render() {
    if (this.state.optimizedWeights.length === 0) {
      return this.renderBuildOptimize();
    }
    const tickers = this.state.optimizedWeights.join(',');
    const { riskMetric } = this.state;
    const params = { symbols: tickers, risk_measure: riskMetric };
    return this.renderOptimizedGraph(params);
  }
}

Optimize.propTypes = {
  match: PropTypes.object.isRequired,
  buildoptimize: PropTypes.object,
  dispatch: PropTypes.func,
  isClientMode: PropTypes.bool,
  user_region: PropTypes.string,
};

Optimize.defaultProps = {
  dispatch: () => false,
  buildoptimize: {},
  isClientMode: false,
  user_region: 'CA',
};

export default connect((state) => ({
  buildoptimize: state.BuildOptimize,
  isClientMode: Boolean(localStorage.getItem('client-id')),
  user_region: localStorage.getItem('user_region'),
}))(Optimize);
